import React from 'react';
import { Page } from '../Page';
import { Droplets, Zap, Award } from 'lucide-react';
export function SupplementElectrolytes() {
  return <Page pageNumber={21} variant="light" data-id="element-2238">
      <div className="flex h-full gap-10" data-id="element-2239">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2240">
          <img src="https://cdn.magicpatterns.com/uploads/3vpcu2q2uyntMMUQT4U38Z/pasted-image.png" alt="Thorne Daily Electrolytes" className="w-full max-w-[300px] object-contain" data-id="element-2241" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2242">
          <div className="mb-6 pt-4" data-id="element-2243">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2244">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2245">
              Daily Electrolytes
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2246">
              Replace what GLP-1 side effects deplete
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2247" />
          </div>

          <div className="mb-6" data-id="element-2248">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2249">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2250">
              Dehydration and electrolyte imbalance are among the most common
              GLP-1 side effects. Nausea, vomiting, and reduced fluid intake all
              deplete electrolytes. Zero sugar and only 5 calories, critical
              when every calorie counts.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-2251">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2252">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2253">480mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2254">
                Sodium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2255">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2256">99mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2257">
                Potassium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2258">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2259">40mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2260">
                Magnesium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-2261">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-2262">0g</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-2263">
                Sugar
              </p>
            </div>
          </div>

          <div className="mb-6" data-id="element-2264">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2265">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2266">
              <li className="flex gap-2" data-id="element-2267">
                <Droplets className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2268" />
                <span data-id="element-2269">
                  Supports energy and reduces fatigue/brain fog from electrolyte
                  depletion
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2270">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2271" />
                <span data-id="element-2272">
                  Himalayan pink salt, naturally sweetened/flavored, 3 flavors
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2273">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2274" />
                <span data-id="element-2275">Stick packs for on-the-go, NSF Certified for Sport</span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2276">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2277">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2278">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2279">
                <strong data-id="element-2280">1 stick pack</strong> in at least 12oz water daily
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2281">
                30 stick packs per bag • 5 calories per serving
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2282">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2283" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2284">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}